import React, { useState } from 'react';
import { Box, Tab } from '@mui/material';

import TabList from '@mui/lab/TabList';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import useStyles from '../styles';
import WeatherForecast from './WeatherForecast';
import WeatherReport from './WeatherReport';
import IrrigationDataTab from './IrrigationDataTab';

interface WeatherTabsProps {
  showForecastTab?: boolean;
  showIrrigationDataTab?: boolean;
  irrigationDays?: string[];
  vertical?: boolean;
}

const WeatherTabs = ({
  showForecastTab = true,
  showIrrigationDataTab = false,
  irrigationDays = [],
  vertical = true,
}: WeatherTabsProps) => {
  const classes = useStyles();
  const [selectedTab, setSelectedTab] = useState('1');

  const handleChange = (event: React.SyntheticEvent, newValue: string) => {
    setSelectedTab(newValue);
  };

  return (
    <TabContext value={selectedTab}>
      <Box sx={{
        borderBottom: 0,
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
      }}>
        <Box sx={{ flexShrink: 0 }}>
          <TabList onChange={handleChange} aria-label="sector tabs">
            <Tab label="Clima Actual" value="1" className={classes.tabLabel}/>
            {showForecastTab && <Tab label="Pronóstico" value="2" className={classes.tabLabel}/>}
            {showIrrigationDataTab && (
              <Tab label="Datos periodo riego" value="3" className={classes.tabLabel}/>
            )}
          </TabList>
        </Box>
        <Box sx={{ flex: 1, overflow: 'auto', minHeight: 0 }}>
          <TabPanel value="1" className={classes.tabPanel}>
            <WeatherReport vertical={vertical} hideStationSelectorAndUpdate={vertical} />
          </TabPanel>
          {showForecastTab && (
            <TabPanel value="2" className={classes.tabPanel}>
              <WeatherForecast />
            </TabPanel>
          )}
          {showIrrigationDataTab && (
            <TabPanel value="3" className={classes.tabPanel}>
              <IrrigationDataTab days={irrigationDays} />
            </TabPanel>
          )}
        </Box>
      </Box>
    </TabContext>
  );
};

export default WeatherTabs;
